import Label from 'types/Label';
import { Brand } from 'types/Brand';
import { Context } from 'types/Context';
import { KioskImages } from 'types/KioskImages';
import { AbstractMedia } from 'types/AbstractMedia';
import { KioskModel, KioskType } from 'types/KioskTypes';

import RefData from 'modules/refData/types/RefData';
import {
  ConfiguredWorkflows,
  PhoneNumber,
  SelfServiceOrigin,
  SelfServiceType
} from 'modules/selfServices/types/SelfService';
import { WhatsAppDetails } from '../../auth/types/LoginResponse';
import { ChannelEnum } from '../../auth/types/LoginRequest';

export enum KioskConnectionStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface ContextResponse extends Context {
  backgroundMedia: AbstractMedia,
  brands: Brand[],
  confidentialityPolicyLink?: Label,
  legalNotice?:string;
  courtesyVehicleAvailabilityDate?: string,
  dealerCountry?: DealerCountry,
  id?: string,
  interventionLastMessageChannel?: ChannelEnum;
  isAvailable?: boolean,
  isEmergencyMode?: boolean,
  isPublic: boolean,
  isTokenExpired?: boolean,
  kioskBackgroundMedia: AbstractMedia,
  kioskConnectionStatus?: KioskConnectionStatus,
  kioskDealers? : Dealer[],
  kioskId? : string,
  kioskModel?: KioskModel,
  kioskImages?: KioskImages,
  kioskName? : string,
  kioskSpeech?: Label,
  kioskType?: KioskType,
  kioskTypes?: KioskType[],
  origin: SelfServiceOrigin,
  refData?: RefData,
  registration?: string,
  selfServiceAvailableTypes?: Partial<Record<SelfServiceType, SelfServiceOrigin[]>>,
  selfServiceKioskExplanationMedias?: AbstractMedia[],
  type?: SelfServiceType,
  theme?: string,
  whatsApp: WhatsAppDetails;
}

export enum ConnectionTypeLogin {
  MFA = 'MFA',
  CODE = 'CODE',
  TOKEN = 'TOKEN',
}

export interface Dealer {
  id: string,
  dealerName: string,
  dealerCustomerLanguage: string,
  confidentialityPolicyLink?: Label,
  generalTermsConditionsLink?: Label,
  selfServicePhoneNumber: PhoneNumber,
  selfServiceAvailableTypes: Partial<Record<SelfServiceType, SelfServiceOrigin[]>>,
  selfServiceKioskExplanationMedias?: AbstractMedia[],
  brands?: Brand[],
  dealerCountry?: DealerCountry,
  timezone?: string,
  workflows?: ConfiguredWorkflows,
  legalNotice?: string,
}

export interface DealerCountry {
  code: string,
  prefix: number,
  valueAddedTax: number,
  currency: string,
  currencyIsoCode: string,
  senderIdAllowed: boolean,
  appCountry: boolean,
  name: string,
  timezones?: Record<string, string>,
}
